import gql from 'graphql-tag'

export const fetchProductsToCartBulk = gql(`
mutation ($cart_id: String!, $cartItems: [CartItemInput!]!) {
  addProductsToCart(
    cartId: $cart_id
    cartItems: $cartItems
  ) {
      user_errors {
        code
        message
      }
    }
  }
`)
